import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "details-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "no-params-container"
}
const _hoisted_4 = {
  key: 2,
  class: "detail-content"
}
const _hoisted_5 = { class: "info-tags-container" }
const _hoisted_6 = { class: "info-tags" }
const _hoisted_7 = { class: "tag-label" }
const _hoisted_8 = { class: "tag-value" }
const _hoisted_9 = { class: "drawing-entry-sticky" }
const _hoisted_10 = {
  key: 0,
  class: "projects-section"
}
const _hoisted_11 = {
  key: 0,
  class: "special-attributes"
}
const _hoisted_12 = { class: "special-attributes-list" }
const _hoisted_13 = { class: "attribute-label" }
const _hoisted_14 = {
  key: 1,
  class: "detailed-data"
}
const _hoisted_15 = ["data-main-table-id"]
const _hoisted_16 = { class: "table-summary-header" }
const _hoisted_17 = { class: "table-title" }
const _hoisted_18 = { class: "table-summary" }
const _hoisted_19 = {
  key: 0,
  class: "option-example-images"
}
const _hoisted_20 = {
  key: 0,
  class: "option-example-placeholder"
}
const _hoisted_21 = {
  key: 1,
  class: "option-example-placeholder"
}
const _hoisted_22 = { class: "option-example-placeholder" }
const _hoisted_23 = { class: "option-example-placeholder" }
const _hoisted_24 = { class: "table-summary-actions" }
const _hoisted_25 = {
  key: 0,
  class: "single-special-attrs"
}
const _hoisted_26 = {
  key: 1,
  class: "main-table-images"
}
const _hoisted_27 = { class: "images-grid-small" }
const _hoisted_28 = { class: "image-thumb-wrapper" }
const _hoisted_29 = {
  key: 0,
  class: "image-error-placeholder"
}
const _hoisted_30 = {
  key: 1,
  class: "image-error-placeholder"
}
const _hoisted_31 = { class: "image-error-small" }
const _hoisted_32 = { class: "image-loading-small" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "image-remark-badge-text" }
const _hoisted_35 = { class: "remark-image-preview-dialog" }
const _hoisted_36 = { class: "remark-image-preview-stage" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "remark-image-preview-note" }
const _hoisted_39 = { class: "remark-image-preview-note-value" }
const _hoisted_40 = { class: "operating-project-dialog" }
const _hoisted_41 = { class: "op-building-tabs" }
const _hoisted_42 = { class: "op-building-meta" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "op-drawing-layout" }
const _hoisted_45 = { class: "op-floor-list" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "op-drawing-panel" }
const _hoisted_48 = { class: "op-drawing-code" }
const _hoisted_49 = {
  key: 0,
  class: "op-pdf-preview"
}
const _hoisted_50 = {
  key: 1,
  class: "op-error-text"
}
const _hoisted_51 = {
  key: 1,
  class: "op-image-preview"
}
const _hoisted_52 = { class: "image-error-small" }
const _hoisted_53 = {
  key: 3,
  class: "op-error-text"
}
const _hoisted_54 = { class: "raw-data-change-dialog-body" }
const _hoisted_55 = {
  key: 1,
  class: "raw-data-change-sub-table"
}
const _hoisted_56 = { key: 0 }

import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import PageHeader from '@/components/PageHeader.vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { ArrowLeft, ArrowRight, Warning, Download, Picture, Loading } from '@element-plus/icons-vue'
import getData, { list, ParameterSettings } from '@/network/index'
import { useDetailStore } from '@/store/detailStore'
import { getMenuPathByComponent } from '@/utils/menuRoute'
import { useRouteTitle } from '@/utils/useRouteTitle'

interface DetailImageItem {
  fileName: string
  url: string
  remark?: string
  loading?: boolean
  error?: boolean
}

interface RemarkImageSource {
  fileName: string
  remark: string
}

// 备注图像列表（按主表ID分组）
interface OperatingFloorDrawing {
  floorNumber: number
  fileCode: string
  fileUrl: string
  loading: boolean
  loadError: boolean
}

interface OperatingBuilding {
  id: string
  name: string
  code: string
  floors: number // 地上层数（与楼栋信息维护页一致，层数字段只代表地上层数）
  basementFloors: number // 地下层数（0 表示无地下层）
  floorDrawings: OperatingFloorDrawing[]
}

const CHANGE_SUB_TABLE_KEY = '检测原始数据详细数据子表集合'
const CHANGE_POSITION_STORAGE_KEY = 'original-detection-change-position'

interface ChangePositionCache {
  detailId: string
  mainTableId: string
  savedAt: number
}

interface ExcelImageGroup {
  summary: string
  images: DetailImageItem[]
}

const PHOTO_CACHE_DB_NAME = 'detail-photo-cache'
const PHOTO_CACHE_DB_VERSION = 1
const PHOTO_CACHE_STORE_NAME = 'photos'
const PHOTO_CACHE_SESSION_COOKIE = 'photo_cache_session'
const PHOTO_CACHE_LEGACY_PREFIX = 'detail-photo-cache:'

type ImageMapRef = typeof remarkImagesByMainTable | typeof optionExampleImagesByMainTable
interface PendingImagePatch {
  imageMapRef: ImageMapRef
  mainTableId: string
  fileName: string
  patch: Partial<DetailImageItem>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'details',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const detailStore = useDetailStore()
const pageTitle = useRouteTitle('原始记录详情', false)
const originalDetectionListPath = () => getMenuPathByComponent(
  '/RawDataManagement/OriginalDetectionList/index.vue',
  '/原始数据管理/原始检测数据列表'
)

// 设置页面标题
const setPageTitle = (title: string) => {
  document.title = title
}

// 响应式数据
const loading = ref(false)
const downloading = ref(false)
const detailData = ref<any>(null)

const remarkImagesByMainTable = ref<Map<string, DetailImageItem[]>>(new Map())
const optionExampleImagesByMainTable = ref<Map<string, DetailImageItem[]>>(new Map())
// 下载Excel前等待详情页现场图片全部完成，避免下载到不完整文件。
let remarkImagesLoadingPromise: Promise<void> = Promise.resolve()
const remarkImagePreviewVisible = ref(false)
const remarkPreviewImages = ref<DetailImageItem[]>([])
const remarkPreviewIndex = ref(0)
const activeRemarkPreviewImage = computed(() => remarkPreviewImages.value[remarkPreviewIndex.value])

// 获取指定主表的图片列表
const getMainTableImages = (mainData: any) => {
  const mainTableId = mainData.Id || mainData.id
  return remarkImagesByMainTable.value.get(String(mainTableId)) || []
}

const openRemarkImagePreview = (mainData: any, imageIndex: number) => {
  const sourceImages = getMainTableImages(mainData)
  const targetImage = sourceImages[imageIndex]
  const previewImages = sourceImages.filter(image => !image.loading && !image.error && image.url)
  const previewIndex = previewImages.findIndex(image => image === targetImage)
  if (previewIndex < 0) return

  remarkPreviewImages.value = previewImages
  remarkPreviewIndex.value = previewIndex
  remarkImagePreviewVisible.value = true
}

const changeRemarkPreviewImage = (offset: number) => {
  const nextIndex = remarkPreviewIndex.value + offset
  if (nextIndex >= 0 && nextIndex < remarkPreviewImages.value.length) {
    remarkPreviewIndex.value = nextIndex
  }
}

const getOptionExampleImages = (mainData: any) => {
  const mainTableId = mainData.Id || mainData.id
  return optionExampleImagesByMainTable.value.get(String(mainTableId)) || []
}

const operatingProjectDialogVisible = ref(false)
const operatingProjectLoading = ref(false)
const operatingProjectDetailId = ref('')
const operatingProjectBuildings = ref<OperatingBuilding[]>([])
const activeOperatingBuildingIndex = ref(0)
const activeOperatingFloorIndex = ref(0)
const operatingProjectFileCache = new Map<string, string>()

const RAW_DATA_CHANGE_READONLY_FIELDS = new Set(['Id'])
const RAW_DATA_CHANGE_SUB_TABLE_READONLY_FIELDS = new Set(['Id', '检测原始数据详细数据主表id'])

const changeDialogVisible = ref(false)
const changeDialogLoading = ref(false)
const changeSubmitting = ref(false)
const changeLoadingMainTableId = ref('')
const changeQueryId = ref('')
const changeEditingData = ref<Record<string, any> | null>(null)
const changeComplexFieldTexts = ref<Record<string, string>>({})
const changeSourceProject = ref<Record<string, any> | null>(null)
const changeSourceMainData = ref<Record<string, any> | null>(null)
const changeOpenedMainTableId = ref('')

const toNonEmptyString = (value: unknown): string => {
  if (value === null || value === undefined) return ''
  const text = String(value).trim()
  if (!text || text === 'null' || text === 'undefined') return ''
  return text
}

const normalizeRemarkImage = (source: unknown): RemarkImageSource | null => {
  if (typeof source === 'string') {
    const fileName = toNonEmptyString(source)
    return fileName ? { fileName, remark: '' } : null
  }

  if (Array.isArray(source)) {
    const fileName = toNonEmptyString(source[0])
    return fileName ? { fileName, remark: toNonEmptyString(source[1]) } : null
  }

  if (!source || typeof source !== 'object') return null
  const item = source as Record<string, unknown>
  const fileName = toNonEmptyString(
    item['文件名'] ?? item['fileName'] ?? item['名称'] ?? item['name'] ?? item['图片名称'] ?? item['图片']
  )
  if (!fileName) return null
  return {
    fileName,
    remark: toNonEmptyString(item['备注'] ?? item['remark'] ?? item['说明'] ?? item['内容'])
  }
}

const parseRemarkImages = (source: unknown): RemarkImageSource[] => {
  if (!Array.isArray(source)) return []
  return source.map(normalizeRemarkImage).filter((item): item is RemarkImageSource => item !== null)
}

const toPositiveInt = (value: unknown, fallback: number): number => {
  const parsed = Number(value)
  if (!Number.isFinite(parsed) || parsed <= 0) return fallback
  return Math.floor(parsed)
}

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

const getMainTableRecordId = (mainData: Record<string, unknown> | null | undefined): string => {
  if (!mainData) return ''
  return toNonEmptyString(mainData.Id ?? mainData.id)
}

const getCurrentDetailId = (): string => {
  if (detailStore.isParamsValid) return detailStore.getDetailId
  return toNonEmptyString(route.query.id)
}

const saveChangePositionCache = (detailId: string, mainTableId: string) => {
  if (!detailId || !mainTableId) return
  const payload: ChangePositionCache = {
    detailId,
    mainTableId,
    savedAt: Date.now()
  }
  sessionStorage.setItem(CHANGE_POSITION_STORAGE_KEY, JSON.stringify(payload))
}

const readChangePositionCache = (): ChangePositionCache | null => {
  const text = sessionStorage.getItem(CHANGE_POSITION_STORAGE_KEY)
  if (!text) return null
  try {
    const parsed = JSON.parse(text) as ChangePositionCache
    if (!parsed?.detailId || !parsed?.mainTableId) return null
    return parsed
  } catch {
    return null
  }
}

const clearChangePositionCache = () => {
  sessionStorage.removeItem(CHANGE_POSITION_STORAGE_KEY)
}

const scrollToMainTablePosition = (mainTableId: string): boolean => {
  if (!mainTableId) return false
  const target = document.querySelector<HTMLElement>(`.data-table-container[data-main-table-id="${mainTableId}"]`)
  if (!target) return false
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return true
}

const restoreChangePositionIfNeeded = async (detailId: string) => {
  const cached = readChangePositionCache()
  if (!cached) return
  if (cached.detailId !== detailId) return

  await nextTick()
  for (let i = 0; i < 12; i += 1) {
    await sleep(150)
    await nextTick()
    if (scrollToMainTablePosition(cached.mainTableId)) {
      clearChangePositionCache()
      return
    }
  }
}

function deepClone<T>(value: T): T {
  try {
    return JSON.parse(JSON.stringify(value)) as T
  } catch {
    return value
  }
}

const isComplexValue = (value: unknown): boolean => {
  return value !== null && typeof value === 'object'
}

const getOperatingProjectId = (source: Record<string, unknown> | null | undefined): string => {
  if (!source) return ''
  const idValue =
    source['经营项目id'] ??
    source['经营项目ID'] ??
    source.operatingProjectId ??
    source.businessProjectId
  return toNonEmptyString(idValue)
}

const detailBuildingList = computed(() => {
  const buildingList = detailData.value?.建筑列表
  return Array.isArray(buildingList) ? (buildingList as Array<Record<string, unknown>>) : []
})

const findBuildingForMainTable = (mainData: Record<string, unknown> | null | undefined) => {
  if (!mainData) return null
  if (!detailBuildingList.value.length) return null

  const mainBuildingIdCandidates = [
    mainData['建筑ID'],
    mainData['建筑id'],
    mainData['建筑Id'],
    mainData['楼栋ID'],
    mainData['楼栋id'],
    mainData['楼栋Id']
  ].map(toNonEmptyString).filter(Boolean)

  if (mainBuildingIdCandidates.length > 0) {
    const matchedById = detailBuildingList.value.find((building) => {
      const buildingId = toNonEmptyString(building['Id'] ?? building['id'])
      return !!buildingId && mainBuildingIdCandidates.includes(buildingId)
    })
    if (matchedById) return matchedById
  }

  const mainBuildingName = toNonEmptyString(mainData['建筑名称'] ?? mainData['楼栋名称'])
  if (mainBuildingName) {
    const matchedByName = detailBuildingList.value.find((building) => {
      return toNonEmptyString(building['名称']) === mainBuildingName
    })
    if (matchedByName) return matchedByName
  }

  return null
}

const getRawDataChangeQueryId = (mainData: Record<string, unknown> | null | undefined): string => {
  const building = findBuildingForMainTable(mainData)
  if (building) {
    const buildingProjectId = toNonEmptyString(building['Id'] ?? building['Id'])
    if (buildingProjectId) return buildingProjectId
  }
  return detailOperatingProjectId.value
}

const buildOperatingProjectBuildings = (detail: Record<string, unknown> | null | undefined): OperatingBuilding[] => {
  if (!detail) return []
  const buildingList = Array.isArray(detail['建筑列表']) ? (detail['建筑列表'] as Array<Record<string, unknown>>) : []

  return buildingList.map((building, index) => {
    const drawingPackage = Array.isArray(building['图纸包']) ? (building['图纸包'] as Array<Record<string, unknown>>) : []
    // 与楼栋信息维护页一致：层数只代表地上层数，地下层数单独记录
    const aboveGroundFloors = toPositiveInt(building['层数'], 0)
    const basementFloors = toPositiveInt(building['地下层数'], 0)

    // 完整楼层号（升序，地下在前、地上在后），如 地下2层 + 地上3层 => [-2, -1, 1, 2, 3]
    let floorNumbers: number[] = []
    for (let i = basementFloors; i >= 1; i--) floorNumbers.push(-i)
    for (let i = 1; i <= aboveGroundFloors; i++) floorNumbers.push(i)

    // 兼容旧数据：没有地下层数、甚至缺少层数字段时，按图纸包行数兜底生成地上楼层
    if (floorNumbers.length === 0) {
      floorNumbers = Array.from({ length: Math.max(1, drawingPackage.length) }, (_, i) => i + 1)
    }

    const floorToDrawingRow = new Map<number, Record<string, unknown>>()
    const untaggedRows: Array<Record<string, unknown>> = []

    // 优先按图纸自身的“层数”字段归属楼层（可为 -1/-2 等地下层）；
    // 没有层数标记的图纸（旧数据）保留原顺序，在后面按“最小未占用楼层”补位
    for (const row of drawingPackage) {
      const rawFloor = row?.['层数']
      const taggedFloor = rawFloor === null || rawFloor === undefined || rawFloor === '' ? Number.NaN : Number(rawFloor)
      if (Number.isFinite(taggedFloor) && floorNumbers.includes(taggedFloor) && !floorToDrawingRow.has(taggedFloor)) {
        floorToDrawingRow.set(taggedFloor, row)
      } else {
        untaggedRows.push(row)
      }
    }

    const floorDrawings: OperatingFloorDrawing[] = floorNumbers.map(floorNumber => {
      const drawingRow = floorToDrawingRow.get(floorNumber) || untaggedRows.shift() || {}
      const fileCode = toNonEmptyString(
        drawingRow['内容'] ??
        drawingRow['fileName'] ??
        drawingRow['fileCode']
      )
      return {
        floorNumber,
        fileCode,
        fileUrl: '',
        loading: false,
        loadError: false
      }
    })

    return {
      id: toNonEmptyString(building.Id ?? building.id) || `building-${index + 1}`,
      name: toNonEmptyString(building['名称']) || `${index + 1}号楼`,
      code: toNonEmptyString(building['报告编号'] ?? building['编码']),
      floors: aboveGroundFloors,
      basementFloors,
      floorDrawings
    }
  })
}

const clearOperatingProjectFileCache = () => {
  for (const url of operatingProjectFileCache.values()) {
    if (url.startsWith('blob:')) {
      URL.revokeObjectURL(url)
    }
  }
  operatingProjectFileCache.clear()
}

const parseDownloadResponseToUrl = (res: any): string => {
  if (res instanceof Blob) {
    return URL.createObjectURL(res)
  }

  const data = res?.response ?? res?.data ?? res
  if (data instanceof Blob) {
    return URL.createObjectURL(data)
  }

  if (typeof data === 'string') {
    if (data.startsWith('blob:') || data.startsWith('data:') || data.startsWith('http')) {
      return data
    }
    return `data:image/jpeg;base64,${data}`
  }

  return ''
}

const isPdfDrawing = (fileCode: string): boolean => /\.pdf($|\?)/i.test(fileCode)

const detailOperatingProjectId = computed(() => getOperatingProjectId(detailData.value))

const changeTopLevelFieldKeys = computed(() => {
  if (!changeEditingData.value) return []
  return Object.keys(changeEditingData.value).filter((fieldKey) => fieldKey !== CHANGE_SUB_TABLE_KEY)
})

const changeSubTableRows = computed(() => {
  if (!changeEditingData.value) return []
  const rows = changeEditingData.value[CHANGE_SUB_TABLE_KEY]
  return Array.isArray(rows) ? (rows as Array<Record<string, any>>) : []
})

const changeFormatHorizontalHeaders = computed(() => {
  const formatDesc = changeSourceProject.value?.检测原始数据检测数据格式描述
  const headers = formatDesc?.横向标题
  return Array.isArray(headers) ? (headers as string[]) : []
})

const changeVisibleSubTableColumns = computed(() => {
  if (changeFormatHorizontalHeaders.value.length > 0) {
    return ['Header', ...changeFormatHorizontalHeaders.value.map((_, index) => `_${index + 1}`)]
  }
  return changeSubTableColumns.value
})

const getSubTableColumnWeight = (key: string) => {
  if (key === 'Header') return 0
  const numberedColumnMatch = key.match(/^_(\d+)$/)
  if (numberedColumnMatch) return Number(numberedColumnMatch[1])
  if (key === 'ISDELETED') return 900
  if (key === '检测原始数据详细数据主表id') return 901
  if (key === 'Id') return 902
  return 500
}

const changeSubTableColumns = computed(() => {
  const columnSet = new Set<string>()
  for (const row of changeSubTableRows.value) {
    Object.keys(row).forEach((key) => columnSet.add(key))
  }

  return Array.from(columnSet).sort((a, b) => {
    const weightA = getSubTableColumnWeight(a)
    const weightB = getSubTableColumnWeight(b)
    if (weightA !== weightB) return weightA - weightB
    return a.localeCompare(b)
  })
})

const getChangeSubTableColumnLabel = (columnKey: string) => {
  if (columnKey === 'Header') return '行号'
  const match = columnKey.match(/^_(\d+)$/)
  if (match && changeFormatHorizontalHeaders.value.length > 0) {
    const columnIndex = Number(match[1]) - 1
    const title = changeFormatHorizontalHeaders.value[columnIndex]
    if (title) {
      return getTransformedTitle(
        title,
        changeSourceProject.value,
        changeEditingData.value || changeSourceMainData.value
      )
    }
  }
  return columnKey
}

const getChangeSubTableColumnClassName = (columnKey: string) => {
  const match = columnKey.match(/^_(\d+)$/)
  if (!match || !changeSourceProject.value) return ''
  const columnIndex = Number(match[1]) - 1
  return hasDividerLine(changeSourceProject.value, columnIndex) ? 'divider-column' : ''
}

const initChangeComplexFieldTexts = () => {
  const next: Record<string, string> = {}
  if (!changeEditingData.value) {
    changeComplexFieldTexts.value = next
    return
  }

  for (const fieldKey of changeTopLevelFieldKeys.value) {
    const fieldValue = changeEditingData.value[fieldKey]
    if (isComplexValue(fieldValue)) {
      next[fieldKey] = JSON.stringify(fieldValue, null, 2)
    }
  }
  changeComplexFieldTexts.value = next
}

const isChangeFieldComplex = (fieldKey: string): boolean => {
  if (!changeEditingData.value) return false
  return isComplexValue(changeEditingData.value[fieldKey])
}

const isChangeFieldReadonly = (fieldKey: string): boolean => {
  return RAW_DATA_CHANGE_READONLY_FIELDS.has(fieldKey)
}

const isSubTableFieldReadonly = (fieldKey: string): boolean => {
  return RAW_DATA_CHANGE_SUB_TABLE_READONLY_FIELDS.has(fieldKey)
}

const applyChangeComplexField = (fieldKey: string): boolean => {
  if (!changeEditingData.value) return false
  if (!(fieldKey in changeComplexFieldTexts.value)) return true

  const raw = changeComplexFieldTexts.value[fieldKey]
  if (raw === undefined || raw === null || raw.trim() === '') {
    changeEditingData.value[fieldKey] = null
    return true
  }

  try {
    changeEditingData.value[fieldKey] = JSON.parse(raw)
    return true
  } catch {
    ElMessage.error(`${fieldKey} 不是合法JSON，请修正后再提交`)
    return false
  }
}

const syncAllComplexFields = (): boolean => {
  for (const fieldKey of Object.keys(changeComplexFieldTexts.value)) {
    if (!applyChangeComplexField(fieldKey)) return false
  }
  return true
}

const handleRawDataChangeDialogClosed = () => {
  changeEditingData.value = null
  changeComplexFieldTexts.value = {}
  changeDialogLoading.value = false
  changeSubmitting.value = false
  changeLoadingMainTableId.value = ''
  changeQueryId.value = ''
  changeSourceProject.value = null
  changeSourceMainData.value = null
  changeOpenedMainTableId.value = ''
}

const activeOperatingBuilding = computed(() => {
  return operatingProjectBuildings.value[activeOperatingBuildingIndex.value] || null
})

const activeOperatingFloor = computed(() => {
  const building = activeOperatingBuilding.value
  if (!building) return null
  return building.floorDrawings[activeOperatingFloorIndex.value] || null
})

const loadOperatingFloorFile = async (floor: OperatingFloorDrawing | null) => {
  if (!floor || !floor.fileCode) return
  if (floor.loading) return

  if (operatingProjectFileCache.has(floor.fileCode)) {
    floor.fileUrl = operatingProjectFileCache.get(floor.fileCode) || ''
    floor.loadError = false
    return
  }

  floor.loading = true
  floor.loadError = false
  try {
    const res = await ParameterSettings.operatingProjectDownload({ fileName: floor.fileCode })
    const fileUrl = parseDownloadResponseToUrl(res)
    if (!fileUrl) {
      floor.loadError = true
      return
    }
    floor.fileUrl = fileUrl
    operatingProjectFileCache.set(floor.fileCode, fileUrl)
  } catch (error) {
    console.error(`加载经营项目图纸失败: ${floor.fileCode}`, error)
    floor.loadError = true
  } finally {
    floor.loading = false
  }
}

const loadActiveOperatingFloorFile = async () => {
  await loadOperatingFloorFile(activeOperatingFloor.value)
}

const handleOperatingBuildingChange = async (index: number) => {
  activeOperatingBuildingIndex.value = index
  activeOperatingFloorIndex.value = 0
  await loadActiveOperatingFloorFile()
}

const handleOperatingFloorChange = async (index: number) => {
  activeOperatingFloorIndex.value = index
  await loadActiveOperatingFloorFile()
}

const loadOperatingProjectDefinition = async (operatingProjectId: string) => {
  if (!operatingProjectId) {
    operatingProjectDetailId.value = ''
    operatingProjectBuildings.value = []
    return
  }

  try {
    operatingProjectLoading.value = true
    const res = await ParameterSettings.operatingProjectById({ id: operatingProjectId })

    if (res && (res.status === 200 || res.status === 0) && res.success && res.response) {
      clearOperatingProjectFileCache()
      operatingProjectDetailId.value = operatingProjectId
      operatingProjectBuildings.value = buildOperatingProjectBuildings(res.response)
      activeOperatingBuildingIndex.value = 0
      activeOperatingFloorIndex.value = 0
      return
    }

    operatingProjectDetailId.value = operatingProjectId
    operatingProjectBuildings.value = []
  } catch (error) {
    console.error('加载经营项目定义失败:', error)
    operatingProjectDetailId.value = operatingProjectId
    operatingProjectBuildings.value = []
  } finally {
    operatingProjectLoading.value = false
  }
}

const openOperatingProjectDialog = async () => {
  const operatingProjectId = detailOperatingProjectId.value
  if (!operatingProjectId) {
    ElMessage.warning('当前检测数据缺少经营项目ID')
    return
  }

  operatingProjectDialogVisible.value = true

  if (operatingProjectDetailId.value !== operatingProjectId || operatingProjectBuildings.value.length === 0) {
    await loadOperatingProjectDefinition(operatingProjectId)
  }

  await loadActiveOperatingFloorFile()
}

const openRawDataChangeDialog = async (
  mainData: Record<string, unknown>,
  project: Record<string, unknown>
) => {
  const queryId = getRawDataChangeQueryId(mainData)
  if (!queryId) {
    ElMessage.warning('当前数据表未匹配到ID，无法变更')
    return
  }

  const mainTableId = getMainTableRecordId(mainData)
  changeLoadingMainTableId.value = mainTableId
  changeOpenedMainTableId.value = mainTableId
  changeDialogVisible.value = true
  changeDialogLoading.value = true
  changeEditingData.value = null
  changeQueryId.value = queryId
  changeComplexFieldTexts.value = {}
  changeSourceProject.value = deepClone(project)
  changeSourceMainData.value = deepClone(mainData)

  try {
    const res = await list.rawDataChangeById({ id: mainTableId })
    if (res && (res.status === 200 || res.status === 0) && res.success && res.response) {
      changeEditingData.value = deepClone(res.response)
      initChangeComplexFieldTexts()
      return
    }
    ElMessage.error(res?.msg || '获取变更数据失败')
    changeDialogVisible.value = false
  } catch (error) {
    console.error('获取检测原始数据变更详情失败:', error)
    ElMessage.error('获取变更数据失败')
    changeDialogVisible.value = false
  } finally {
    changeDialogLoading.value = false
    changeLoadingMainTableId.value = ''
  }
}

const submitRawDataChange = async () => {
  if (!changeEditingData.value) {
    ElMessage.warning('暂无可提交的变更数据')
    return
  }

  if (!syncAllComplexFields()) return

  try {
    changeSubmitting.value = true
    const payload = deepClone(changeEditingData.value)
    const res = await list.rawDataChangeSubmit(payload)

    if (res && (res.status === 200 || res.status === 0) && res.success) {
      const detailId = getCurrentDetailId()
      const mainTableIdToCache = changeOpenedMainTableId.value || getMainTableRecordId(changeSourceMainData.value)
      saveChangePositionCache(detailId, mainTableIdToCache)
      ElMessage.success('变更完成')
      changeDialogVisible.value = false
      await loadDetailData({ restorePosition: true })
      return
    }

    ElMessage.error(res?.msg || '变更失败')
  } catch (error) {
    console.error('提交检测原始数据变更失败:', error)
    ElMessage.error('变更失败，请稍后重试')
  } finally {
    changeSubmitting.value = false
  }
}

// 计算属性：基本信息项（动态获取所有非空字段）
const basicInfoItems = computed(() => {
  if (!detailData.value) return {}
  
  const items: any = {}
  // 系统字段，不显示在基本信息中
  const systemFields = ['Id', 'ISDELETED', '检测原始数据检测项目集合', 'id']
  
  for (const key in detailData.value) {
    // 跳过系统字段、包含id的字段和空值
    if (!systemFields.includes(key) && 
        !key.toLowerCase().includes('id') &&
        detailData.value[key] !== undefined && 
        detailData.value[key] !== null && 
        detailData.value[key] !== '') {
      items[key] = detailData.value[key]
    }
  }
  return items
})

// 获取字段标签（智能生成）
const getFieldLabel = (key: string) => {
  // 特殊字段映射
  const specialMappings: Record<string, string> = {
    '经营项目id': '经营项目ID',
    'ISDELETED': '是否删除',
    'Id': 'ID'
  }
  
  if (specialMappings[key]) {
    return specialMappings[key]
  }
  
  // 智能转换规则
  let label = key
  
  // 处理下划线命名
  if (key.includes('_')) {
    label = key.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ')
  }
  
  // 处理驼峰命名
  if (key.match(/[a-z][A-Z]/)) {
    label = key.replace(/([a-z])([A-Z])/g, '$1 $2')
  }
  
  // 处理ID字段
  if (key.toLowerCase().endsWith('id')) {
    label = key.replace(/id$/i, 'ID')
  }
  
  return label
}

// 获取标签类型（根据字段名动态判断）
const getTagType = (key: string) => {
  if (key.includes('时间') || key.includes('Time') || key.includes('Date')) {
    return 'info'
  } else if (key.includes('编码') || key.includes('Code') || key.includes('ID') || key.includes('id')) {
    return 'primary'
  } else if (key.includes('名称') || key.includes('Name') || key.includes('Title')) {
    return 'success'
  } else if (key.includes('状态') || key.includes('Status') || key.includes('State')) {
    return 'warning'
  }
  return 'info'
}

// 格式化字段值
const formatFieldValue = (key: string, value: any) => {
  if (key.includes('时间') || key.includes('Time') || key.includes('Date')) {
    return formatDateTime(value)
  }
  return value || '-'
}

// 格式化时间显示
const formatDateTime = (dateTimeStr: string) => {
  if (!dateTimeStr || dateTimeStr === '0001-01-01 00:00:00') {
    return '-'
  }
  try {
    const date = new Date(dateTimeStr)
    if (isNaN(date.getTime())) {
      return '-'
    }
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  } catch (error) {
    return '-'
  }
}

// 转换横向标题，将@@1~4转换为轴线1~4的属性值
const getTransformedTitle = (title: string, project: any, mainData: any) => {
  // 检查是否包含@@1~4的模式（如@@2的高度）
  const match = title.match(/@@([1-4])/)
  if (match) {
    const axisNumber = match[1]
    const axisKey = `轴线${axisNumber}`
    
    // 首先在mainData中查找轴线属性
    if (mainData && mainData[axisKey]) {
      const axisValue = mainData[axisKey]
      // 如果轴线值为"0"，返回原始标题
      if (axisValue === "0" || axisValue === 0) {
        return title
      }
      // 将@@数字替换为轴线属性值
      return title.replace(/@@([1-4])/, axisValue)
    }
    
    // 如果mainData中没有，再在特殊属性集合中查找
    if (project.检测原始数据检测项目特殊属性集合) {
      const axisAttr = project.检测原始数据检测项目特殊属性集合.find((attr: any) => 
        attr.标题 === axisKey
      )
      if (axisAttr && axisAttr.内容) {
        const axisValue = axisAttr.内容
        // 如果轴线值为"0"，返回原始标题
        if (axisValue === "0" || axisValue === 0) {
          return title
        }
        // 将@@数字替换为轴线属性值
        return title.replace(/@@([1-4])/, axisValue)
      }
    }
    
    // 如果都没找到，返回原始标题
    return title
  }
  
  // 如果不包含@@1~4格式，返回原始标题
  return title
}

// 判断是否有分区线
const hasDividerLine = (project: any, index: number) => {
  const formatDesc = project.检测原始数据检测数据格式描述
  if (formatDesc && formatDesc.分区线 && Array.isArray(formatDesc.分区线)) {
    return formatDesc.分区线[index] === true
  }
  return false
}

const getExcelColumnLetter = (columnNumber: number): string => {
  let result = ''
  let value = columnNumber
  while (value > 0) {
    const remainder = (value - 1) % 26
    result = String.fromCharCode(65 + remainder) + result
    value = Math.floor((value - 1) / 26)
  }
  return result
}

const getRemarkImageGroups = (): ExcelImageGroup[] => {
  const projects = detailData.value?.检测原始数据检测项目集合
  if (!Array.isArray(projects)) return []

  const groups: ExcelImageGroup[] = []
  for (const project of projects) {
    const mainTables = project?.检测原始数据详细数据主表集合
    if (!Array.isArray(mainTables)) continue

    for (const mainData of mainTables) {
      const mainTableId = String(mainData.Id || mainData.id)
      const images = remarkImagesByMainTable.value.get(mainTableId) || []
      if (images.length > 0) {
        groups.push({
          summary: String(mainData.显示摘要 || '未命名数据表'),
          images
        })
      }
    }
  }
  return groups
}

const getExcelImageExtension = (blob: Blob, fileName: string): 'jpeg' | 'png' | 'gif' => {
  const mime = blob.type.toLowerCase()
  if (mime.includes('png') || /\.png$/i.test(fileName)) return 'png'
  if (mime.includes('gif') || /\.gif$/i.test(fileName)) return 'gif'
  return 'jpeg'
}

// 后端 Excel 不包含页面现场照片，这里在保留原始工作表的基础上追加照片工作表。
const appendRemarkImagesToWorkbook = async (sourceBlob: Blob, groups: ExcelImageGroup[]): Promise<Blob> => {
  const excelJsModule = await import('exceljs')
  const ExcelJS = excelJsModule.default || excelJsModule
  const workbook = new ExcelJS.Workbook()
  await workbook.xlsx.load(await sourceBlob.arrayBuffer())

  const worksheetName = workbook.getWorksheet('现场照片') ? '现场照片_1' : '现场照片'
  const worksheet = workbook.addWorksheet(worksheetName)
  worksheet.getColumn(1).width = 80

  const maxImageCount = Math.max(...groups.map(group => group.images.length), 0)
  for (let imageIndex = 0; imageIndex < maxImageCount; imageIndex++) {
    worksheet.getColumn(imageIndex * 2 + 2).width = 18
    worksheet.getColumn(imageIndex * 2 + 3).width = 26
  }

  let currentRow = 1
  for (const group of groups) {
    const titleCell = worksheet.getCell(`A${currentRow}`)
    titleCell.value = group.summary
    titleCell.font = { bold: true, size: 12 }
    titleCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
    worksheet.getRow(currentRow).height = 90

    for (let imageIndex = 0; imageIndex < group.images.length; imageIndex++) {
      const image = group.images[imageIndex]
      const imageColumn = imageIndex * 2 + 2
      const remarkColumnLetter = getExcelColumnLetter(imageColumn + 1)
      const remarkCell = worksheet.getCell(`${remarkColumnLetter}${currentRow}`)
      remarkCell.value = `备注：${image.remark?.trim() || '无'}`
      remarkCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }

      const imageResponse = await fetch(image.url)
      if (!imageResponse.ok) {
        throw new Error(`现场图片下载失败：${image.fileName}`)
      }
      const imageBlob = await imageResponse.blob()
      const imageId = workbook.addImage({
        buffer: await imageBlob.arrayBuffer(),
        extension: getExcelImageExtension(imageBlob, image.fileName)
      })

      worksheet.addImage(imageId, {
        tl: { col: imageColumn - 1, row: currentRow - 1 },
        ext: { width: 120, height: 80 }
      })
    }

    currentRow++
  }

  const buffer = await workbook.xlsx.writeBuffer()
  return new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
}

// 下载Excel
const handleDownloadExcel = async () => {
  try {
    downloading.value = true

    const imageItems = Array.from(remarkImagesByMainTable.value.values()).flat()
    if (imageItems.some((image) => image.loading)) {
      ElMessage.info('现场图片仍在加载，已等待全部图片加载完成后继续下载')
    }

    await remarkImagesLoadingPromise

    const failedImages = Array.from(remarkImagesByMainTable.value.values())
      .flat()
      .filter((image) => image.error || !image.url)
    if (failedImages.length > 0) {
      ElMessage.warning(`有 ${failedImages.length} 张现场图片加载失败，已停止下载，请刷新后重试`)
      return
    }
    
    // 获取当前数据的ID
    let id = ''
    if (detailStore.isParamsValid) {
      id = detailStore.getDetailId
    } else {
      id = route.query.id as string
    }
    
    if (!id) {
      ElMessage.error('缺少ID参数，无法下载')
      return
    }
    
    const res = await list.downloadExcel({ id })

    // 后端文件作为基础 Excel，现场照片由详情页加载后追加到工作簿。
    const sourceBlob = res instanceof Blob
      ? res
      : new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    const imageGroups = getRemarkImageGroups()
    const blob = imageGroups.length > 0
      ? await appendRemarkImagesToWorkbook(sourceBlob, imageGroups)
      : sourceBlob

    // 创建Blob对象并下载
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    // 使用数据名称作为文件名，如果没有则使用默认名称
    const fileName = detailData.value?.名称 ? `${detailData.value.名称}.xlsx` : '检测原始数据.xlsx'
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    
    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载Excel失败:', error)
    ElMessage.error('下载失败，请重试')
  } finally {
    downloading.value = false
  }
}

// 返回列表
const goBack = () => {
  // 先取消进行中的图片加载，避免大量图片解码/请求占满主线程导致返回点击延迟响应
  cancelImageLoading()
  // 如果store中有来源路径，则返回到来源路径，否则使用浏览器后退
  const fromPath = detailStore.getFromPath
  if (fromPath) {
    router.push(fromPath)
  } else {
    router.go(-1)
  }
}

// 加载备注图像（按主表分组）
// ========== 现场照片本地缓存（IndexedDB + 浏览器会话标记：关闭浏览器自动清空） ==========
// 说明：图片以 Blob 原样缓存在 IndexedDB，容量大、无 base64 膨胀，手机拍摄的大图也能缓存；
// 通过 session cookie 判断浏览器会话，关闭整个浏览器后 cookie 失效，下次进入自动清空图片缓存。
let photoCacheDbPromise: Promise<IDBDatabase | null> | null = null
let photoCacheSessionChecked = false

const getCookie = (name: string): string => {
  try {
    const matched = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`))
    return matched ? decodeURIComponent(matched[1]) : ''
  } catch {
    return ''
  }
}

// 写入浏览器会话标记（不设置过期时间，关闭浏览器后自动失效）
const setPhotoCacheSessionCookie = (value: string) => {
  try {
    document.cookie = `${PHOTO_CACHE_SESSION_COOKIE}=${encodeURIComponent(value)}; path=/; SameSite=Lax`
  } catch {
    // 忽略
  }
}

const openPhotoCacheDb = (): Promise<IDBDatabase | null> => {
  if (photoCacheDbPromise) return photoCacheDbPromise
  photoCacheDbPromise = new Promise((resolve) => {
    try {
      if (typeof indexedDB === 'undefined') {
        resolve(null)
        return
      }
      const request = indexedDB.open(PHOTO_CACHE_DB_NAME, PHOTO_CACHE_DB_VERSION)
      request.onupgradeneeded = () => {
        const db = request.result
        if (!db.objectStoreNames.contains(PHOTO_CACHE_STORE_NAME)) {
          db.createObjectStore(PHOTO_CACHE_STORE_NAME)
        }
      }
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => resolve(null)
      request.onblocked = () => resolve(null)
    } catch {
      resolve(null)
    }
  })
  return photoCacheDbPromise
}

// 清空图片缓存（IndexedDB 主存储 + 兼容清理旧版 localStorage/sessionStorage 缓存）
const clearAllCachedPhotos = async () => {
  const db = await openPhotoCacheDb()
  if (db) {
    await new Promise<void>((resolve) => {
      try {
        const transaction = db.transaction(PHOTO_CACHE_STORE_NAME, 'readwrite')
        transaction.objectStore(PHOTO_CACHE_STORE_NAME).clear()
        transaction.oncomplete = () => resolve()
        transaction.onerror = () => resolve()
        transaction.onabort = () => resolve()
      } catch {
        resolve()
      }
    })
  }
  try {
    const localKeys: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith(PHOTO_CACHE_LEGACY_PREFIX)) localKeys.push(key)
    }
    localKeys.forEach((key) => localStorage.removeItem(key))
    const sessionKeys: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith(PHOTO_CACHE_LEGACY_PREFIX)) sessionKeys.push(key)
    }
    sessionKeys.forEach((key) => sessionStorage.removeItem(key))
  } catch {
    // 忽略
  }
}

// 保证处于同一个浏览器会话：
// - cookie 存在 => 同一浏览器会话（关过页签也算），保留图片缓存；
// - cookie 不存在 => 新浏览器会话（上次关闭了整个浏览器），清空旧图片缓存并重新打标记。
const ensurePhotoCacheSession = async () => {
  if (photoCacheSessionChecked) return
  photoCacheSessionChecked = true
  if (getCookie(PHOTO_CACHE_SESSION_COOKIE)) return
  await clearAllCachedPhotos()
  setPhotoCacheSessionCookie(`${Date.now()}-${Math.random().toString(36).slice(2)}`)
}

// 兼容不同的接口返回形态，取出真正的 Blob
const resolvePhotoBlob = (res: any): Blob | null => {
  if (res instanceof Blob) return res
  if (res?.data instanceof Blob) return res.data
  return null
}

// 读取缓存：命中则直接返回 Blob，无需再请求接口
const getCachedPhotoBlob = async (fileName: string): Promise<Blob | null> => {
  if (!fileName) return null
  await ensurePhotoCacheSession()
  const db = await openPhotoCacheDb()
  if (!db) return null
  return new Promise((resolve) => {
    try {
      const transaction = db.transaction(PHOTO_CACHE_STORE_NAME, 'readonly')
      const request = transaction.objectStore(PHOTO_CACHE_STORE_NAME).get(fileName)
      request.onsuccess = () => {
        const value = request.result
        resolve(value instanceof Blob ? value : null)
      }
      request.onerror = () => resolve(null)
    } catch {
      resolve(null)
    }
  })
}

// 写入缓存：写入失败（配额超限、隐私模式等）不影响页面展示
const setCachedPhotoBlob = async (fileName: string, blob: Blob) => {
  if (!fileName || !blob) return
  await ensurePhotoCacheSession()
  const db = await openPhotoCacheDb()
  if (!db) return
  await new Promise<void>((resolve) => {
    try {
      const transaction = db.transaction(PHOTO_CACHE_STORE_NAME, 'readwrite')
      transaction.objectStore(PHOTO_CACHE_STORE_NAME).put(blob, fileName)
      transaction.oncomplete = () => resolve()
      transaction.onerror = () => resolve()
      transaction.onabort = () => resolve()
    } catch {
      resolve()
    }
  })
}

// ========== 图片加载性能优化 ==========
// 1) 并发池：同时最多加载 4 张，避免大量请求 + 图片解码占满主线程导致点击无响应
const createLimitedRunner = (maxConcurrent: number) => {
  let active = 0
  const queue: Array<() => void> = []
  const next = () => {
    if (active >= maxConcurrent) return
    const run = queue.shift()
    if (!run) return
    active += 1
    run()
  }
  return <T>(task: () => Promise<T>): Promise<T> =>
    new Promise<T>((resolve, reject) => {
      queue.push(() => {
        task()
          .then(resolve, reject)
          .finally(() => {
            active -= 1
            next()
          })
      })
      next()
    })
}
const runWithImageLimit = createLimitedRunner(4)

// 2) 同一帧内合并多张图片的更新，避免"每加载完一张就整页重渲染"
const imagePendingPatches = new Map<string, PendingImagePatch>()
let imageFlushScheduled = false

// 3) 取消令牌：切换记录 / 返回 / 卸载时让进行中的图片任务立即失效
let imageLoadEpoch = 0
const cancelImageLoading = () => {
  imageLoadEpoch += 1
  imagePendingPatches.clear()
}

// 4) 就地修改图片项（不再复制整个 Map / 数组）
const applyImagePatch = ({ imageMapRef, mainTableId, fileName, patch }: PendingImagePatch) => {
  const images = imageMapRef.value.get(mainTableId)
  if (!images) return
  const image = images.find((item) => item.fileName === fileName)
  if (!image) return
  if (image.url?.startsWith('blob:') && patch.url && patch.url !== image.url) {
    URL.revokeObjectURL(image.url)
  }
  Object.assign(image, patch)
}

const flushImagePatches = () => {
  imageFlushScheduled = false
  const pending = Array.from(imagePendingPatches.values())
  imagePendingPatches.clear()
  pending.forEach(applyImagePatch)
}

const replaceImageItem = (
  imageMapRef: ImageMapRef,
  mainTableId: string,
  fileName: string,
  patch: Partial<DetailImageItem>
) => {
  const kind = imageMapRef === remarkImagesByMainTable ? 'remark' : 'option'
  imagePendingPatches.set(`${kind}:${mainTableId}:${fileName}`, {
    imageMapRef,
    mainTableId,
    fileName,
    patch
  })
  if (imageFlushScheduled) return
  imageFlushScheduled = true
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(flushImagePatches)
  } else {
    setTimeout(flushImagePatches, 16)
  }
}

const loadRemarkImages = (imagesByMainTable: Map<string, RemarkImageSource[]>): Promise<void> => {
  if (!imagesByMainTable || imagesByMainTable.size === 0) {
    remarkImagesByMainTable.value = new Map()
    remarkImagesLoadingPromise = Promise.resolve()
    return remarkImagesLoadingPromise
  }

  // 记录本次加载的版本，切页 / 返回后旧任务自动失效
  const epoch = imageLoadEpoch
  const isStale = () => epoch !== imageLoadEpoch

  const resultMap = new Map<string, DetailImageItem[]>()
  const tasks: Promise<void>[] = []
  
  for (const [mainTableId, imageList] of imagesByMainTable.entries()) {
    const images = imageList.map((image) => ({
      fileName: image.fileName,
      remark: image.remark,
      url: '',
      loading: true,
      error: false
    }))

    if (images.length > 0) {
      resultMap.set(mainTableId, images)
    }

    imageList.forEach(({ fileName }) => {
      tasks.push(
        runWithImageLimit(async () => {
          if (isStale()) return
          // 1. 命中本地缓存则直接使用，不再请求接口
          const cachedBlob = await getCachedPhotoBlob(fileName)
          if (isStale()) return
          if (cachedBlob) {
            replaceImageItem(remarkImagesByMainTable, mainTableId, fileName, {
              url: window.URL.createObjectURL(cachedBlob),
              loading: false,
              error: false
            })
            return
          }

          // 2. 无缓存则请求接口，成功后写入本地缓存（关闭浏览器自动清空）
          try {
            const res: any = await list.downloadPhoto({ 文件名: fileName })
            if (isStale()) return
            const blob = resolvePhotoBlob(res)
            if (!blob) {
              throw new Error('图片数据格式不正确')
            }
            replaceImageItem(remarkImagesByMainTable, mainTableId, fileName, {
              url: window.URL.createObjectURL(blob),
              loading: false,
              error: false
            })
            await setCachedPhotoBlob(fileName, blob)
          } catch (error) {
            if (isStale()) return
            console.error(`加载图片失败: ${fileName}`, error)
            replaceImageItem(remarkImagesByMainTable, mainTableId, fileName, {
              url: '',
              loading: false,
              error: true
            })
          }
        })
      )
    })
  }
  
  remarkImagesByMainTable.value = resultMap
  remarkImagesLoadingPromise = Promise.allSettled(tasks).then(() => undefined)
  return remarkImagesLoadingPromise
}

const clearOptionExampleImages = () => {
  for (const images of optionExampleImagesByMainTable.value.values()) {
    for (const image of images) {
      if (image.url?.startsWith('blob:')) {
        URL.revokeObjectURL(image.url)
      }
    }
  }
  optionExampleImagesByMainTable.value = new Map()
}

// 释放现场照片的 blob URL（IndexedDB 中的缓存不受影响）
const clearRemarkImages = () => {
  for (const images of remarkImagesByMainTable.value.values()) {
    for (const image of images) {
      if (image.url?.startsWith('blob:')) {
        URL.revokeObjectURL(image.url)
      }
    }
  }
  remarkImagesByMainTable.value = new Map()
}

const loadOptionExampleImages = (imagesByMainTable: Map<string, string[]>) => {
  clearOptionExampleImages()
  if (!imagesByMainTable || imagesByMainTable.size === 0) return

  const epoch = imageLoadEpoch
  const isStale = () => epoch !== imageLoadEpoch

  const resultMap = new Map<string, DetailImageItem[]>()
  const tasks: Promise<void>[] = []

  for (const [mainTableId, imageList] of imagesByMainTable.entries()) {
    const images = imageList.map((fileName) => ({
      fileName,
      url: '',
      loading: true,
      error: false
    }))

    if (images.length > 0) {
      resultMap.set(mainTableId, images)
    }

    imageList.forEach((fileName) => {
      tasks.push(
        runWithImageLimit(async () => {
          if (isStale()) return
          try {
            const res = await ParameterSettings.clientDownload({ fileName })
            if (isStale()) return
            const url = parseDownloadResponseToUrl(res)
            if (!url) throw new Error('图片内容为空')
            replaceImageItem(optionExampleImagesByMainTable, mainTableId, fileName, {
              url,
              loading: false,
              error: false
            })
          } catch (error) {
            if (isStale()) return
            console.error(`加载选项示意图失败: ${fileName}`, error)
            replaceImageItem(optionExampleImagesByMainTable, mainTableId, fileName, {
              url: '',
              loading: false,
              error: true
            })
          }
        })
      )
    })
  }

  optionExampleImagesByMainTable.value = resultMap
  Promise.allSettled(tasks)
}

const addUniqueImageFile = (imageList: string[], fileName: string) => {
  const normalized = toNonEmptyString(fileName)
  if (normalized && !imageList.includes(normalized)) {
    imageList.push(normalized)
  }
}

const parseOptionWithImage = (option: unknown): { label: string; fileName: string } | null => {
  const optionText = toNonEmptyString(option)
  if (!optionText) return null

  const [label, fileName] = optionText.split('|||')
  const normalizedLabel = toNonEmptyString(label)
  const normalizedFileName = toNonEmptyString(fileName)

  if (!normalizedLabel || !normalizedFileName) return null
  return { label: normalizedLabel, fileName: normalizedFileName }
}

const splitSelectedOptionValues = (value: unknown): string[] => {
  const selectedValue = toNonEmptyString(value)
  if (!selectedValue) return []

  return selectedValue
    .split(/[,，;；、|]/)
    .map((item) => toNonEmptyString(item))
    .filter(Boolean)
}

const collectSelectedOptionImages = (project: any, mainTable: any): string[] => {
  const formatDesc = project?.检测原始数据检测数据格式描述
  const optionColumns = Array.isArray(formatDesc?.选项) ? formatDesc.选项 : []
  const subRows = Array.isArray(mainTable?.检测原始数据详细数据子表集合)
    ? mainTable.检测原始数据详细数据子表集合
    : []

  if (optionColumns.length === 0 || subRows.length === 0) return []

  const selectedImages: string[] = []

  optionColumns.forEach((options: unknown, columnIndex: number) => {
    if (!Array.isArray(options) || options.length === 0) return

    const optionImageMap = new Map<string, string>()
    options.forEach((option) => {
      const parsed = parseOptionWithImage(option)
      if (parsed) {
        optionImageMap.set(parsed.label, parsed.fileName)
      }
    })

    if (optionImageMap.size === 0) return

    const fieldKey = `_${columnIndex + 1}`
    subRows.forEach((row: any) => {
      splitSelectedOptionValues(row?.[fieldKey]).forEach((selectedValue) => {
        const fileName = optionImageMap.get(selectedValue)
        if (fileName) {
          addUniqueImageFile(selectedImages, fileName)
        }
      })
    })
  })

  return selectedImages
}

// 加载详情数据
const loadDetailData = async (options?: { restorePosition?: boolean }) => {
  // 切换记录时取消上一轮未完成的图片加载
  cancelImageLoading()
  const shouldRestorePosition = options?.restorePosition ?? true
  // 优先从store获取参数，如果store中没有或已过期，则从query参数获取
  const id = getCurrentDetailId()
  
  if (!id) {
    ElMessage.error('缺少ID参数，正在返回列表页')
    setTimeout(() => {
      const fromPath = detailStore.getFromPath || originalDetectionListPath()
      router.push(fromPath)
    }, 1500)
    return
  }
  
  try {
    loading.value = true

    const res = await getData<{ status: number; success: boolean; response: Record<string, unknown> }>("list/listById", { id }, [])
    
    if (res && res.status === 200 && res.success && res.response) {
    detailData.value = res.response

    // 调试：输出每条主表的单条数据特殊属性（开发联调后可删除）
    const projects = (res.response['检测原始数据检测项目集合'] as any[]) || []
    projects.forEach((project: any) => {
      const mainTables = project['检测原始数据详细数据主表集合'] || []
      mainTables.forEach((mainTable: any) => {
        const attrs = mainTable['检测原始数据检测项目单条数据特殊属性集合']
        if (attrs && attrs.length > 0) {
          console.log('[调试-单条属性] 主表Id:', mainTable.Id || mainTable.id, '属性:', attrs)
        } else {
          console.log('[调试-单条属性] 主表Id:', mainTable.Id || mainTable.id, '无单条属性或为空')
        }
      })
    })

    // 设置页面标题
      const name = res.response['名称'] as string || '原始记录详情'
      setPageTitle(`${name} - 详情`)

      const operatingProjectId = getOperatingProjectId(res.response)
      if (operatingProjectId) {
        await loadOperatingProjectDefinition(operatingProjectId)
      } else {
        operatingProjectDetailId.value = ''
        operatingProjectBuildings.value = []
        clearOperatingProjectFileCache()
      }
      
      // 从检测原始数据检测项目集合中查找备注图像列表和选项示意图（按主表分组）
      const imagesByMainTable = new Map<string, RemarkImageSource[]>()
      const optionExampleImagesByMainTable = new Map<string, string[]>()
      
      if (res.response['检测原始数据检测项目集合'] && Array.isArray(res.response['检测原始数据检测项目集合'])) {
        const projects = res.response['检测原始数据检测项目集合'] as any[]
        
        // 遍历所有检测项目
        for (const project of projects) {
          if (project['检测原始数据详细数据主表集合'] && Array.isArray(project['检测原始数据详细数据主表集合'])) {
            const mainTables = project['检测原始数据详细数据主表集合'] as any[]
            
            // 遍历所有主表，收集备注图像列表
            for (const mainTable of mainTables) {
              const mainTableId = String(mainTable.Id || mainTable.id)
              let imageList: RemarkImageSource[] = []
              const optionExampleImage = toNonEmptyString(mainTable['选项示意图'] ?? mainTable['选项示意'])
              const optionImageList: string[] = []
              
              if (mainTable['备注图像列表'] && Array.isArray(mainTable['备注图像列表'])) {
                imageList = parseRemarkImages(mainTable['备注图像列表'])
              } else if (mainTable['备注图像列表json']) {
                try {
                  const parsed = JSON.parse(mainTable['备注图像列表json'])
                  if (Array.isArray(parsed)) {
                    imageList = parseRemarkImages(parsed)
                  }
                } catch (e) {
                  console.error('解析备注图像列表json失败:', e)
                }
              }
              
              if (imageList.length > 0) {
                imagesByMainTable.set(mainTableId, imageList)
              }

              if (optionExampleImage) {
                addUniqueImageFile(optionImageList, optionExampleImage)
              }

              collectSelectedOptionImages(project, mainTable).forEach((fileName) => {
                addUniqueImageFile(optionImageList, fileName)
              })

              if (optionImageList.length > 0) {
                optionExampleImagesByMainTable.set(mainTableId, optionImageList)
              }
            }
          }
        }
      }
      
      if (imagesByMainTable.size > 0) {
        remarkImagesLoadingPromise = loadRemarkImages(imagesByMainTable)
      } else {
        remarkImagesByMainTable.value = new Map()
        remarkImagesLoadingPromise = Promise.resolve()
      }

      loadOptionExampleImages(optionExampleImagesByMainTable)

      ElMessage.success('数据加载成功')
    } else {
      ElMessage.error('数据加载失败')
    }
  } catch (error) {
    console.error('加载详情数据失败:', error)
    ElMessage.error('数据加载失败')
  } finally {
    loading.value = false
  }

  if (shouldRestorePosition) {
    await restoreChangePositionIfNeeded(id)
  }
}

// 组件挂载时加载数据
onMounted(() => {
  setPageTitle('原始记录详情')
  loadDetailData({ restorePosition: true })
})

onBeforeUnmount(() => {
  // 组件卸载后不再继续加载图片，避免无效任务占用主线程
  cancelImageLoading()
  clearOperatingProjectFileCache()
  clearOptionExampleImages()
  clearRemarkImages()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      size: "page",
      divider: ""
    }, {
      title: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(ArrowLeft),
          onClick: goBack,
          class: "back-button"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" 返回 ")
          ])),
          _: 1
        }, 8, ["icon"]),
        _createElementVNode("span", null, _toDisplayString(_unref(pageTitle)), 1)
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "success",
          icon: _unref(Download),
          onClick: handleDownloadExcel,
          loading: downloading.value,
          class: "download-button"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" 下载Excel ")
          ])),
          _: 1
        }, 8, ["icon", "loading"])
      ]),
      _: 1
    }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_skeleton, {
            rows: 5,
            animated: ""
          })
        ]))
      : (!_unref(route).query.id && !_unref(detailStore).isParamsValid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_empty, { description: "缺少必要参数" }, {
              image: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  size: "64",
                  color: "#909399"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Warning))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: goBack
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("返回列表")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (detailData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_card, {
                class: "info-card",
                shadow: "hover"
              }, {
                header: _withCtx(() => [
                  _createVNode(PageHeader, { size: "card" }, {
                    title: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("基本信息")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(basicInfoItems.value, (value, key) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: String(key),
                          type: getTagType(String(key)),
                          size: "large",
                          class: "info-tag"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(getFieldLabel(String(key))) + "：", 1),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(formatFieldValue(String(key), value)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_tooltip, {
                  content: "查看经营项目楼栋图纸",
                  placement: "left"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "drawing-entry-btn",
                      type: "primary",
                      circle: "",
                      icon: _unref(Picture),
                      loading: operatingProjectLoading.value,
                      disabled: !detailOperatingProjectId.value,
                      onClick: openOperatingProjectDialog
                    }, null, 8, ["icon", "loading", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              (detailData.value.检测原始数据检测项目集合 && detailData.value.检测原始数据检测项目集合.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData.value.检测原始数据检测项目集合, (project, projectIndex) => {
                      return (_openBlock(), _createBlock(_component_el_card, {
                        key: project.Id,
                        class: "project-card",
                        shadow: "hover"
                      }, {
                        header: _withCtx(() => [
                          _createVNode(PageHeader, { size: "card" }, {
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(project.名称), 1)
                            ]),
                            actions: _withCtx(() => [
                              _createVNode(_component_el_tag, {
                                type: "info",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("项目 " + _toDisplayString(Number(projectIndex) + 1), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          (project.检测原始数据检测项目特殊属性集合 && project.检测原始数据检测项目特殊属性集合.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.检测原始数据检测项目特殊属性集合, (attr) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: attr.标题,
                                      class: "attribute-item"
                                    }, [
                                      _createElementVNode("label", _hoisted_13, _toDisplayString(attr.标题) + "：", 1),
                                      _createVNode(_component_el_input, {
                                        "model-value": attr.内容 || '无',
                                        readonly: "",
                                        class: "attribute-input"
                                      }, null, 8, ["model-value"])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (project.检测原始数据详细数据主表集合 && project.检测原始数据详细数据主表集合.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _cache[17] || (_cache[17] = _createElementVNode("h4", null, "详细数据", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.检测原始数据详细数据主表集合, (mainData, mainIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: mainData.Id,
                                    class: "data-table-container",
                                    "data-main-table-id": getMainTableRecordId(mainData)
                                  }, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("span", _hoisted_17, "数据表 " + _toDisplayString(Number(mainIndex) + 1), 1),
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(mainData.显示摘要), 1),
                                      (getOptionExampleImages(mainData).length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOptionExampleImages(mainData), (optionImage, optionImageIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: `${optionImage.fileName}_${optionImageIndex}`,
                                                class: "option-example-image"
                                              }, [
                                                (optionImage.loading)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                      _createVNode(_component_el_icon, { class: "is-loading" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(Loading))
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _cache[10] || (_cache[10] = _createElementVNode("span", null, "加载中", -1))
                                                    ]))
                                                  : (optionImage.error)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                        _createVNode(_component_el_icon, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_unref(Picture))
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "加载失败", -1))
                                                      ]))
                                                    : (_openBlock(), _createBlock(_component_el_image, {
                                                        key: 2,
                                                        src: optionImage.url,
                                                        fit: "contain",
                                                        class: "option-example-thumb",
                                                        "preview-src-list": getOptionExampleImages(mainData).filter(img => !img.error && !img.loading && img.url).map(img => img.url),
                                                        "initial-index": getOptionExampleImages(mainData).filter(img => !img.error && !img.loading && img.url).findIndex(img => img.url === optionImage.url),
                                                        "preview-teleported": true,
                                                        "hide-on-click-modal": true
                                                      }, {
                                                        placeholder: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_22, [
                                                            _createVNode(_component_el_icon, { class: "is-loading" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(Loading))
                                                              ]),
                                                              _: 1
                                                            })
                                                          ])
                                                        ]),
                                                        error: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_23, [
                                                            _createVNode(_component_el_icon, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(Picture))
                                                              ]),
                                                              _: 1
                                                            })
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["src", "preview-src-list", "initial-index"]))
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_24, [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          size: "small",
                                          loading: changeDialogLoading.value && changeLoadingMainTableId.value === String(mainData.Id || mainData.id || ''),
                                          onClick: ($event: any) => (openRawDataChangeDialog(mainData, project))
                                        }, {
                                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode(" 变更 ")
                                          ])),
                                          _: 2
                                        }, 1032, ["loading", "onClick"])
                                      ])
                                    ]),
                                    (mainData.检测原始数据检测项目单条数据特殊属性集合 && mainData.检测原始数据检测项目单条数据特殊属性集合.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainData.检测原始数据检测项目单条数据特殊属性集合, (attr) => {
                                            return (_openBlock(), _createBlock(_component_el_tag, {
                                              key: attr.Id || attr.标题,
                                              type: "success",
                                              size: "small",
                                              effect: "light",
                                              class: "single-special-attr-tag"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(attr.标题) + "：" + _toDisplayString(attr.内容 || '无'), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_table, {
                                      data: mainData.检测原始数据详细数据子表集合,
                                      border: "",
                                      size: "small",
                                      class: "data-table",
                                      "scrollbar-always-on": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_table_column, {
                                          prop: "Header",
                                          label: "行号",
                                          width: "80"
                                        }),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.检测原始数据检测数据格式描述.横向标题, (title, index) => {
                                          return (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: index,
                                            prop: `_${Number(index) + 1}`,
                                            label: getTransformedTitle(title, project, mainData),
                                            width: 120,
                                            "show-overflow-tooltip": "",
                                            "class-name": hasDividerLine(project, Number(index)) ? 'divider-column' : ''
                                          }, null, 8, ["prop", "label", "class-name"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["data"]),
                                    (getMainTableImages(mainData).length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                          _cache[16] || (_cache[16] = _createElementVNode("h5", null, "现场照片", -1)),
                                          _createElementVNode("div", _hoisted_27, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMainTableImages(mainData), (image, imgIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: imgIndex,
                                                class: "image-item-small"
                                              }, [
                                                _createElementVNode("div", _hoisted_28, [
                                                  (image.loading)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                        _createVNode(_component_el_icon, { class: "is-loading" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_unref(Loading))
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "加载中", -1))
                                                      ]))
                                                    : (image.error)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                          _createVNode(_component_el_icon, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(Picture))
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _cache[14] || (_cache[14] = _createElementVNode("span", null, "加载失败", -1))
                                                        ]))
                                                      : (_openBlock(), _createBlock(_component_el_image, {
                                                          key: 2,
                                                          src: image.url,
                                                          fit: "cover",
                                                          class: "thumbnail-image-small",
                                                          onClick: ($event: any) => (openRemarkImagePreview(mainData, imgIndex))
                                                        }, {
                                                          error: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_31, [
                                                              _createVNode(_component_el_icon, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_unref(Picture))
                                                                ]),
                                                                _: 1
                                                              })
                                                            ])
                                                          ]),
                                                          placeholder: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_32, [
                                                              _createVNode(_component_el_icon, { class: "is-loading" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_unref(Loading))
                                                                ]),
                                                                _: 1
                                                              })
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["src", "onClick"])),
                                                  (!image.loading && !image.error)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 3,
                                                        class: "image-remark-badge",
                                                        title: image.remark ? `备注：${image.remark}` : '备注：无'
                                                      }, [
                                                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "image-remark-badge-label" }, "备注", -1)),
                                                        _createElementVNode("span", _hoisted_34, _toDisplayString(image.remark || '无'), 1)
                                                      ], 8, _hoisted_33))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_15))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "暂无检测项目数据"
                  }))
            ]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 3,
              description: "数据加载失败"
            })),
    _createVNode(_component_el_dialog, {
      modelValue: remarkImagePreviewVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((remarkImagePreviewVisible).value = $event)),
      title: "现场照片",
      width: "min(860px, 92vw)",
      top: "6vh",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            (remarkPreviewImages.value.length > 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "remark-preview-nav remark-preview-nav--previous",
                  icon: _unref(ArrowLeft),
                  circle: "",
                  disabled: remarkPreviewIndex.value === 0,
                  "aria-label": "上一张",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeRemarkPreviewImage(-1)))
                }, null, 8, ["icon", "disabled"]))
              : _createCommentVNode("", true),
            (activeRemarkPreviewImage.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: activeRemarkPreviewImage.value.url,
                  class: "remark-image-preview-image",
                  alt: "现场照片"
                }, null, 8, _hoisted_37))
              : _createCommentVNode("", true),
            (remarkPreviewImages.value.length > 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  class: "remark-preview-nav remark-preview-nav--next",
                  icon: _unref(ArrowRight),
                  circle: "",
                  disabled: remarkPreviewIndex.value >= remarkPreviewImages.value.length - 1,
                  "aria-label": "下一张",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeRemarkPreviewImage(1)))
                }, null, 8, ["icon", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "remark-image-preview-note-label" }, "备注", -1)),
            _createElementVNode("span", _hoisted_39, _toDisplayString(activeRemarkPreviewImage.value?.remark || '无'), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: operatingProjectDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((operatingProjectDialogVisible).value = $event)),
      title: "经营项目楼栋与楼层图纸",
      width: "85%",
      top: "5vh",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_40, [
          (!operatingProjectBuildings.value.length)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "未获取到经营项目楼栋图纸数据"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operatingProjectBuildings.value, (building, index) => {
                    return (_openBlock(), _createBlock(_component_el_button, {
                      key: building.id,
                      type: index === activeOperatingBuildingIndex.value ? 'primary' : 'default',
                      onClick: ($event: any) => (handleOperatingBuildingChange(index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(building.name || `楼栋${Number(index) + 1}`), 1)
                      ]),
                      _: 2
                    }, 1032, ["type", "onClick"]))
                  }), 128))
                ]),
                _createVNode(_component_el_divider),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", null, "楼栋名称：" + _toDisplayString(activeOperatingBuilding.value?.name || '-'), 1),
                  _createElementVNode("span", null, "报告编号：" + _toDisplayString(activeOperatingBuilding.value?.code || '-'), 1),
                  _createElementVNode("span", null, "地上层数：" + _toDisplayString(activeOperatingBuilding.value?.floors || 0), 1),
                  ((activeOperatingBuilding.value?.basementFloors || 0) > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, " 地下层数：" + _toDisplayString(activeOperatingBuilding.value?.basementFloors), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeOperatingBuilding.value?.floorDrawings || [], (floorItem, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: floorItem.floorNumber,
                        class: _normalizeClass(['op-floor-item', { active: index === activeOperatingFloorIndex.value }]),
                        onClick: ($event: any) => (handleOperatingFloorChange(index))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(floorItem.floorNumber) + "层", 1),
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: floorItem.fileCode ? 'success' : 'info'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(floorItem.fileCode ? '有图纸' : '无图纸'), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ], 10, _hoisted_46))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    (activeOperatingFloor.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("h4", null, _toDisplayString(activeOperatingFloor.value.floorNumber) + "层图纸", 1),
                          _createElementVNode("p", _hoisted_48, " 图纸编码：" + _toDisplayString(activeOperatingFloor.value.fileCode || '未上传图纸'), 1),
                          (!activeOperatingFloor.value.fileCode)
                            ? (_openBlock(), _createBlock(_component_el_empty, {
                                key: 0,
                                description: "当前楼层未上传图纸"
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (isPdfDrawing(activeOperatingFloor.value.fileCode))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        loading: activeOperatingFloor.value.loading,
                                        onClick: loadActiveOperatingFloorFile
                                      }, {
                                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                                          _createTextVNode(" 加载PDF ")
                                        ])),
                                        _: 1
                                      }, 8, ["loading"]),
                                      (activeOperatingFloor.value.fileUrl)
                                        ? (_openBlock(), _createBlock(_component_el_link, {
                                            key: 0,
                                            href: activeOperatingFloor.value.fileUrl,
                                            target: "_blank",
                                            type: "primary"
                                          }, {
                                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                                              _createTextVNode(" 打开PDF预览 ")
                                            ])),
                                            _: 1
                                          }, 8, ["href"]))
                                        : _createCommentVNode("", true),
                                      (activeOperatingFloor.value.loadError)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_50, "图纸加载失败，请稍后重试"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      (!activeOperatingFloor.value.fileUrl && !activeOperatingFloor.value.loading)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            type: "primary",
                                            onClick: loadActiveOperatingFloorFile
                                          }, {
                                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                                              _createTextVNode(" 加载图纸 ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (activeOperatingFloor.value.loading)
                                        ? (_openBlock(), _createBlock(_component_el_skeleton, {
                                            key: 1,
                                            rows: 4,
                                            animated: ""
                                          }))
                                        : (activeOperatingFloor.value.fileUrl)
                                          ? (_openBlock(), _createBlock(_component_el_image, {
                                              key: 2,
                                              src: activeOperatingFloor.value.fileUrl,
                                              class: "op-floor-image",
                                              fit: "contain",
                                              "preview-src-list": [activeOperatingFloor.value.fileUrl],
                                              "preview-teleported": true
                                            }, {
                                              error: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_52, [
                                                  _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(Picture))
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["src", "preview-src-list"]))
                                          : _createCommentVNode("", true),
                                      (activeOperatingFloor.value.loadError)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_53, "图纸加载失败，请稍后重试"))
                                        : _createCommentVNode("", true)
                                    ]))
                              ], 64))
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 64))
        ])), [
          [_directive_loading, operatingProjectLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: changeDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((changeDialogVisible).value = $event)),
      title: "检测原始数据变更",
      width: "90%",
      top: "20vh",
      "destroy-on-close": "",
      onClosed: handleRawDataChangeDialogClosed
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: changeSubmitting.value,
          onClick: submitRawDataChange
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [
            _createTextVNode(" 完成 ")
          ])),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_54, [
          (!changeEditingData.value && !changeDialogLoading.value)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "未获取到可变更数据"
              }))
            : (changeEditingData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createVNode(_component_el_table, {
                    data: changeSubTableRows.value,
                    border: "",
                    size: "small",
                    "max-height": "420",
                    class: "raw-data-change-table"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeVisibleSubTableColumns.value, (columnKey) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: columnKey,
                          prop: columnKey,
                          label: getChangeSubTableColumnLabel(columnKey),
                          "min-width": "140",
                          "show-overflow-tooltip": "",
                          "class-name": getChangeSubTableColumnClassName(columnKey)
                        }, {
                          default: _withCtx(({ row }) => [
                            (isSubTableFieldReadonly(columnKey))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(row[columnKey]), 1))
                              : (typeof row[columnKey] === 'boolean')
                                ? (_openBlock(), _createBlock(_component_el_switch, {
                                    key: 1,
                                    modelValue: row[columnKey],
                                    "onUpdate:modelValue": ($event: any) => ((row[columnKey]) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (typeof row[columnKey] === 'number')
                                  ? (_openBlock(), _createBlock(_component_el_input_number, {
                                      key: 2,
                                      modelValue: row[columnKey],
                                      "onUpdate:modelValue": ($event: any) => ((row[columnKey]) = $event),
                                      controls: false,
                                      class: "raw-data-change-number-input"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                  : (_openBlock(), _createBlock(_component_el_input, {
                                      key: 3,
                                      modelValue: row[columnKey],
                                      "onUpdate:modelValue": ($event: any) => ((row[columnKey]) = $event),
                                      size: "small",
                                      clearable: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          ]),
                          _: 2
                        }, 1032, ["prop", "label", "class-name"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]))
              : _createCommentVNode("", true)
        ])), [
          [_directive_loading, changeDialogLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})